


































































































































import { Component, Vue } from 'vue-property-decorator'
import { BRow, BCol, BBadge } from 'bootstrap-vue'
import chunk from 'lodash/chunk'
import find from 'lodash/find'

import ProductsApi from '@cms-labs/typescript-api/products'
import {
  ProductAttribute,
  ProductCategory,
  ProductItemPublic,
  ProductType
} from '@cms-labs/typescript-api/products/types'
import {
  emptyProductCategoryInstance,
  emptyProductItemPublic, emptyProductTypeInstance
} from '@cms-labs/typescript-api/products/constants'

import { app } from '../main'
import ProductImagesCarousel from '@/components/products/ProductImagesCarousel.vue'
import AddToCartButton from '@/components/AddToCartButton.vue'
import BreadCrumb from '@/components/BreadCrumb.vue'
import LoadingOverlay from '../components/LoadingOverlay.vue'

@Component({
  components: {
    BRow,
    BCol,
    BBadge,
    BreadCrumb,
    ProductImagesCarousel,
    AddToCartButton,
    LoadingOverlay
  }
})
export default class ProductInstance extends Vue {
  private isLoading = false
  private product: ProductItemPublic = emptyProductItemPublic
  private productType: ProductType | undefined = emptyProductTypeInstance
  private productCategory: ProductCategory | undefined
    = emptyProductCategoryInstance

  private productTypes!: ProductType[] | undefined
  private productQuantity = 1

  private async created (): Promise<void> {
    try {
      this.isLoading = true
      const http = new ProductsApi(app)
      this.product = await http.getProductInstance(
        this.$route.params.productSlurg
      )
      this.productTypes = await http.getProductTypeCollection()

      this.productType = find(
        this.productTypes,
        ['name', this.product.type]
      )
      this.productCategory = find(
        this.productType?.categories,
        ['name', this.product.category]
      )
      this.isLoading = false
    } catch (error) { this.isLoading = false }
  }

  private get productImages () {
    const currentImages = this.product.images
    currentImages.unshift(this.product.thumbnail)
    return currentImages
  }

  private get productFormIsValid (): boolean {
    return (
      Number.isInteger(this.productQuantity) &&
      this.productQuantity > 0
    )
  }

  editQuantity (operation: 'incr' | 'decr'): void {
    if (operation === 'incr') {
      this.productQuantity++
    }
    if (operation === 'decr' && this.productQuantity >= 2) {
      this.productQuantity--
    }
  }

  private getArrayChunks (
    inputArray: Array<ProductAttribute>,
    chunkSize: number
  ) {
    return chunk(inputArray, chunkSize)
  }

  private get productOutOfStock () {
    return this.product.stock !== null && this.product.stock < 1
  }
}
